module.exports = __webpack_public_path__ + "img/eq.e180cc03.png";